module.exports = __webpack_public_path__ + "static/media/closeBtnGray.4ee667c0.svg";